import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

interface FunFact {
  number: number;
  desc: string;
  displayedNumber: number;
  duration?: number;
}

export interface Feature {
  icon: string;
  title: string;
}

export interface Service {
  icon: string;
  title: string;
  desc: string;
}

export interface Team {
  image: string;
  name: string;
  position: string;
}

export interface SocialMedia {
  icon: string;
}

export interface Work {
  img: string;
  title: string;
  category: string;
}

export interface Blog {
  image: string;
  title: string;
  category: string;
  color: string;
  time: string;
}

@Component({
  standalone: false,
  selector: 'app-home-one',
  templateUrl: './home-one.component.html',
  styleUrl: './home-one.component.css'
})
export class HomeOneComponent implements OnInit, OnDestroy {
  // OWl Slider
  customOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:0,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 1,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  slideStore = [
    {
      title: ".Design Lab",
      subtitle: "Digital Production",
      subtitleTwo:"Chaos Agency",
      image: "assets/images/slides/slide-1.jpg"
    },

    {
      title: "Design Studio",
      subtitle: "A Chaos Web Agency.",
      image: "assets/images/slides/slide-2.jpg"
    }

  ];

  //Features
  features: Feature[] = [
    { icon: 'bi-boxes', title: 'Creative Design' },
    { icon: 'bi-brilliance', title: 'Development' },
    { icon: 'bi-exclude', title: 'Implementation' },
    { icon: 'bi-earbuds', title: 'Live Support' }
  ];

  //Services
  services: Service[] = [
    {
      icon: 'bi-laptop',
      title: 'Responsive',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-exclude',
      title: 'Development',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-gear',
      title: 'Implementation',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-chat-dots-fill',
      title: 'Live Support',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-layers-fill',
      title: 'Pixel Perfect',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-trophy-fill',
      title: 'Award Winning',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    }
  ];

  // OWl Slider
  brandsCarousel: OwlOptions = {
    loop: true,
    dots: false,
    margin:50,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
  }

  brandStore = [
    {img: "brand-1.png"},
    {img: "brand-2.png"},
    {img: "brand-3.png"},
    {img: "brand-4.png"},
    {img: "brand-5.png"},
    {img: "brand-6.png"}
  ];

  // Funfacts One
  funFacts: FunFact[] = [
    { number: 179, desc: "Projects Done", displayedNumber: 0, duration: 2000 },
    { number: 27, desc: "Employees", displayedNumber: 0, duration: 3000 },
    { number: 1000, desc: "Happy Clients", displayedNumber: 0, duration: 2500 },
    { number: 214, desc: "Hours of Meeting", displayedNumber: 0, duration: 2500 }
  ];

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  filterPortfolio(category: string): void {
    // Simple filter - just for button styling
    // The HTML is static, so filtering doesn't change display
  }

  private intervals: any[] = [];

  ngOnInit(): void {
    this.startCounters(this.funFacts);
  }

  // Generic Counter Starter
  startCounters(items: (FunFact)[]): void {
    items.forEach(item => this.animateCounter(item));
  }

  // Generic Counter Animation
  animateCounter(item: FunFact): void {
    const duration = item.duration ?? 4000;
    const intervalTime = 30;
    const increment = item.number / (duration / intervalTime);

    const interval = setInterval(() => {
      item.displayedNumber = Math.min(item.displayedNumber + increment, item.number);

      if (item.displayedNumber >= item.number) {
        item.displayedNumber = item.number;
        clearInterval(interval);
      }
    }, intervalTime);

    this.intervals.push(interval);
  }

  ngOnDestroy(): void {
    this.intervals.forEach(clearInterval);
  }

  // Team
  teamMembers: Team[] = [
    {
      image: 'assets/images/team/team-01.jpg',
      name: 'James Brewer',
      position: 'Digital Designer'
    },
    {
      image: 'assets/images/team/team-02.jpg',
      name: 'Mesha Albert',
      position: 'Senior User Interface'
    },
    {
      image: 'assets/images/team/team-03.jpg',
      name: 'Arthur Stewart',
      position: 'Founder & CEO'
    },
    {
      image: 'assets/images/team/team-04.jpg',
      name: 'Eden Charles',
      position: 'Art Director'
    }
  ];

  // Works
  works:Work[] =[
    {
      img:'1.jpg',
      title:'Amazing Illustration',
      category:'Web'
    },
    {
      img:'2.jpg',
      title:'Flyer Design',
      category:'Graphic'
    },
    {
      img:'3.jpg',
      title:'Dafur Dagegen',
      category:'Brand'
    },
    {
      img:'4.jpg',
      title:'Motherlands Cars',
      category:'Graphics'
    },
    {
      img:'5.jpg',
      title:'T-shirt Design',
      category:'Wordpress'
    },
    {
      img:'6.jpg',
      title:'Business Cards',
      category:'Graphic'
    }
  ];

  //Rotate Elements
  rotationDegreeLeft = 0;
  rotationDegreeRight = 0;

  @HostListener('window:wheel', ['$event'])
  onWindowScroll(event: WheelEvent) {
    if (event.deltaY > 0) {
      // Mouse wheel down: rotate 90 degrees
      this.rotationDegreeLeft += 90;
      this.rotationDegreeRight -= 90;
    } else {
      // Optional: mouse wheel up pe wapis rotate karna ho tou
      this.rotationDegreeLeft -= 90;
      this.rotationDegreeRight += 90;
    }
  }

  // OWl Slider
  testimonialOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 3,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  testimonials = [
    {
      name: "Melina Walber",
      position: "manager@Chaos.io",
      image: "avatar-4.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Doris Campos",
      position: "founder@Chaos.io",
      image: "avatar-5.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Melina Walber",
      position: "manager@Chaos.io",
      image: "avatar-6.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Doris Campos",
      position: "founder@Chaos.io",
      image: "avatar-1.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    }
  ];

  //Blogs
  posts: Blog[] = [
    {
      image: 'assets/images/blogs/post-01.jpg',
      title: 'Kobe Steel plant that supplied plane components being checked',
      category: 'News',
      color: 'purple-color',
      time: '7 hours ago'
    },
    {
      image: 'assets/images/blogs/post-02.jpg',
      title: 'They say that a picture is worth a thousand words',
      category: 'Events',
      color: 'pink-color',
      time: 'Yesterday'
    },
    {
      image: 'assets/images/blogs/post-03.jpg',
      title: 'NewsBike | NY News Satire, Parody and Spoof News',
      category: 'Blog',
      color: 'blue-color',
      time: 'December 21, 2024'
    }
  ];
}
